import { loadStripe, type Stripe } from '@stripe/stripe-js'

const stripeCache: Record<string, Promise<Stripe | null>> = {}

export function getStripeInstance(connectedAccountId: string): Promise<Stripe | null> {
  if (!connectedAccountId) {
    throw new Error('connectedAccountId is required for direct charges')
  }

  if (!stripeCache[connectedAccountId]) {
    stripeCache[connectedAccountId] = loadStripe(
      import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
      // @ts-expect-error -- developerTools is valid but not yet in @stripe/stripe-js types
      { stripeAccount: connectedAccountId, developerTools: { assistant: { enabled: false } } },
    )
  }

  return stripeCache[connectedAccountId]
}

export function clearStripeCache(): void {
  Object.keys(stripeCache).forEach(key => delete stripeCache[key])
}
